import { useEffect, useState } from "react";
import { api, formatIDR } from "../lib/api";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../components/ui/table";

const ACTION_LABELS = {
    ai_create_exam: "AI membuat pemeriksaan baru",
    ai_create_package: "AI membuat paket",
};

function fmtTime(s) {
    try {
        return new Date(s).toLocaleString("id-ID", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return s;
    }
}

export default function AuditLog() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/audit-logs")
            .then((res) => setLogs(res.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="space-y-6" data-testid="audit-log-page">
            <div>
                <div className="label-uppercase mb-2">Data Akuntansi</div>
                <h1 className="font-heading text-4xl tracking-tight font-semibold">Audit Log</h1>
                <p className="text-[#4A5E57] mt-2 max-w-3xl">
                    Dokumentasi otomatis: pemeriksaan baru yang dibuat AI (harga jual estimasi
                    pasaran, unit cost dikosongkan) dan paket hasil AI.
                </p>
            </div>

            <div className="surface-card overflow-hidden">
                {loading ? (
                    <div className="p-8 text-[#4A5E57]">Memuat...</div>
                ) : logs.length === 0 ? (
                    <div className="p-8 text-center text-[#6A9C89]" data-testid="audit-empty">
                        Belum ada catatan. Log terisi saat AI membuat pemeriksaan/paket baru.
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <Table>
                            <TableHeader>
                                <TableRow className="bg-[#E9EFEA]">
                                    <TableHead>Waktu</TableHead>
                                    <TableHead>Aksi</TableHead>
                                    <TableHead>Rincian</TableHead>
                                    <TableHead>Oleh</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {logs.map((l) => (
                                    <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                                        <TableCell className="whitespace-nowrap text-sm">
                                            {fmtTime(l.created_at)}
                                        </TableCell>
                                        <TableCell className="text-sm font-medium">
                                            {ACTION_LABELS[l.action] || l.action}
                                        </TableCell>
                                        <TableCell className="text-sm">
                                            {l.action === "ai_create_exam" ? (
                                                <>
                                                    <div className="font-medium">
                                                        {l.detail?.name}{" "}
                                                        <span className="text-xs text-[#6A9C89]">
                                                            ({l.detail?.code} • {l.detail?.kind})
                                                        </span>
                                                    </div>
                                                    <div className="text-xs text-[#4A5E57]">
                                                        Harga jual (pasaran):{" "}
                                                        {formatIDR(l.detail?.price)} • Unit cost:
                                                        kosong
                                                    </div>
                                                    <div className="text-xs text-[#6A9C89]">
                                                        Prompt: {l.detail?.source_prompt}
                                                    </div>
                                                </>
                                            ) : l.action === "ai_create_package" ? (
                                                <>
                                                    <div className="font-medium">
                                                        {l.detail?.package_name}
                                                    </div>
                                                    <div className="text-xs text-[#4A5E57]">
                                                        {l.detail?.matched_count} dari master •{" "}
                                                        {l.detail?.created_count} dibuat AI
                                                    </div>
                                                    <div className="text-xs text-[#6A9C89]">
                                                        Prompt: {l.detail?.source_prompt}
                                                    </div>
                                                </>
                                            ) : (
                                                JSON.stringify(l.detail)
                                            )}
                                        </TableCell>
                                        <TableCell className="text-sm whitespace-nowrap">
                                            {l.user_email || "-"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                )}
            </div>
        </div>
    );
}
